<script>
export default {
  name: 'TabPanePro',
  props: {
    label: String,
    name: [String, Number],
    disabled: {
      // 是否禁用这一项
      type: Boolean,
      default: false, // 默认不禁用
    },
  },
  computed: {
    // 控制根据高亮的tab显示对应标签页内容
    isActiveToShowContent() {
      const activeName = this.$parent.value
      const currentName = this.name

      return activeName === currentName
    },
  },
}
</script>

<template>
  <transition name="slide-fade">
    <div
      v-show="isActiveToShowContent"
      class="tab-pane-pro"
    >
      <slot />
    </div>
  </transition>
</template>

<style lang='scss' scoped>
.tab-pane-pro {
  padding: 12px;
}
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(100%);
  opacity: 0;
}
</style>
